"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateImages = exports.CustomerTemplate = exports.ContentData = void 0;
var contentData_1 = require("./api/contentData");
Object.defineProperty(exports, "ContentData", { enumerable: true, get: function () { return __importDefault(contentData_1).default; } });
var customerTemplate_1 = require("./api/customerTemplate");
Object.defineProperty(exports, "CustomerTemplate", { enumerable: true, get: function () { return __importDefault(customerTemplate_1).default; } });
var images_1 = require("./api/images");
Object.defineProperty(exports, "TemplateImages", { enumerable: true, get: function () { return __importDefault(images_1).default; } });
